import { executeLauncherOption, executeDtvOption } from './values/dtv';
import { UrlParameterValue, UrlParameter } from '../../classes';

const getOptionValues = () => {
  const tvLauncher = new UrlParameterValue('launcher', executeLauncherOption);
  const dtv = new UrlParameterValue('dtv', executeDtvOption);
  const optionValues = [dtv, tvLauncher];

  return optionValues;
};

export const getOptionParameter = () => {
  const values = getOptionValues();
  return new UrlParameter('options', values);
};
